import React from 'react';
import { Award, ExternalLink, CheckCircle, X } from 'lucide-react';
export function ClosingSection() {
  return <div className="bg-white py-16 border-t border-[#E8E4DD]" data-id="element-5">
      <div className="editorial-container" data-id="element-6">
        {/* Why Faith & Fig Took the #1 Spot */}
        <div className="mb-12" data-id="element-7">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-6" data-id="element-8">
            Why Faith & Fig 4:14 Saffron Took the #1 Spot
          </h2>
          <div className="prose prose-lg max-w-none" data-id="element-9">
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-10">
              <strong data-id="element-11">The Right Dosing:</strong> 30mg of Safr'Inside™
              clinically proven to work as effectively as focus meds without any
              of the side effects. It's the most potent saffron extract
              available and the same standardized form used in clinical trials.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-12">
              <strong data-id="element-13">The Right Mechanism:</strong> Supports dopamine and the
              brain's full calm-focus-regulation cycle.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-14">
              <strong data-id="element-15">The Right Values:</strong> Faith-aligned, addresses
              stimulant usage guilt, honors the plants & the mind God gave you.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed" data-id="element-16">
              <strong data-id="element-17">The Right Results:</strong> Smooth mornings, steadier
              focus & better emotional control.
            </p>
          </div>
        </div>

        {/* Why You Should Stop Relying on Willpower Alone */}
        <div className="mb-12" data-id="element-18">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-6" data-id="element-19">
            Why You Should Stop Relying on Willpower Alone
          </h2>
          <div className="prose prose-lg max-w-none" data-id="element-20">
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-21">
              Many Christian women think they just need to "try harder," pray
              more, or be more disciplined. But if your brain's dopamine and
              calm-regulate-focus circuit is breaking down, no amount of
              willpower will fix it.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed" data-id="element-22">
              Saffron offers natural support for the system itself so that your
              neurodivergent brain can be your superpower, not a setback.
            </p>
          </div>
        </div>

        {/* Buying Guide */}
        <div className="mb-12" data-id="element-23">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-6" data-id="element-24">
            Buying Guide: What to Look For in Focus & Mood Supplements
          </h2>

          <div className="bg-white border border-[#E8E4DD] rounded-xl p-8 mb-6" data-id="element-25">
            <ul className="space-y-3" data-id="element-26">
              {['Clinical potency and dosage of active ingredients', 'All-day, consistent support (8+ hours)', 'Full-cycle support + dopamine regulation', 'Single-ingredient purity or transparent formulas (no mystery blends)', 'Faith-friendly brand (understands your values and concerns)', 'Risk Free Money-back guarantee (not all bodies are made the same, their return policy should reflect that)'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-27">
                  <CheckCircle className="w-5 h-5 text-[#C9A961] flex-shrink-0 mt-0.5" data-id="element-28" />
                  <span className="text-[#1A2332]/80" data-id="element-29">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-red-50 border border-red-200 rounded-xl p-8" data-id="element-30">
            <h3 className="text-xl font-bold text-[#1A2332] mb-4" data-id="element-31">
              Red Flags to Avoid:
            </h3>
            <ul className="space-y-3" data-id="element-32">
              {['Vague proprietary blends', 'Under-dosed clinical amounts', 'Stimulant-heavy formulas that cause jitters or anxiety', 'No specific clinical trials to back up claims'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-33">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-34" />
                  <span className="text-[#1A2332]/80" data-id="element-35">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mb-12" data-id="element-36">
          <h2 className="text-3xl font-bold text-[#1A2332] mb-6" data-id="element-37">
            Is Saffron Supplementation the Answer?
          </h2>
          <div className="prose prose-lg max-w-none" data-id="element-38">
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-39">
              Nothing is a magic bullet, and saffron isn't a replacement for
              prayer, good habits, or responsible medical care when needed.
            </p>
            <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-40">
              But when well-formulated and when dosed according to clinical
              research saffron can make a meaningful difference in your ability
              to stay calm, focused, and emotionally steady throughout your day.
            </p>
          </div>
        </div>

        {/* Special Offer Section */}
        <div className="bg-[#C9A961]/5 border-l-4 border-[#C9A961] p-8 rounded-r-xl mb-12" data-id="element-41">
          <h2 className="text-2xl font-bold text-[#1A2332] mb-4" data-id="element-42">
            Special Offer for HerMindBodySoul Readers:
          </h2>
          <p className="text-[#1A2332]/80 leading-relaxed mb-4" data-id="element-43">
            We reached out to Faith&Fig after our testing, and they agreed to
            extend their Black Friday offer:
          </p>
          <ul className="space-y-3" data-id="element-44">
            {['Up to 30% OFF multi-month bundles and 20% OFF for first-time users', 'Free shipping', 'Full 90-day, no-questions-asked guarantee'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-45">
                <span className="text-[#C9A961] font-bold text-lg" data-id="element-46">✓</span>
                <span className="text-[#1A2332]/80" data-id="element-47">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Final CTA Box - Our Top Pick */}
        <div className="bg-gradient-to-br from-[#1A2332] to-[#1A2332]/90 text-white p-8 rounded-xl shadow-xl" data-id="element-48">
          <div className="flex items-start gap-4 mb-6" data-id="element-49">
            <Award className="w-8 h-8 text-[#C9A961] flex-shrink-0" data-id="element-50" />
            <div data-id="element-51">
              <h3 className="text-2xl font-bold mb-2" data-id="element-52">
                Our Top Pick – Faith & Fig 4:14 Saffron
              </h3>
            </div>
          </div>

          <ul className="space-y-3 mb-8" data-id="element-53">
            {[<span key="saffron" data-id="element-54">
                Clinically-dosed saffron (30mg{' '}
                <a href="https://activinside.com/ingredients/safrinside/" target="_blank" rel="noopener noreferrer" className="text-[#C9A961] hover:text-[#B89851] underline" data-id="element-55">
                  Safr'Inside™ Extract
                </a>
                )
              </span>, "Supports dopamine & the brain's calm-focus-regulation cycle", '100% Traceable & Ethically Sourced', 'No emotional blunting or stimulant side effects', 'Thousands of women report increased productivy and life-changing results'].map((highlight, index) => <li key={index} className="flex items-start gap-3" data-id="element-56">
                <span className="text-[#C9A961] font-bold" data-id="element-57">✓</span>
                <span className="text-white/90" data-id="element-58">{highlight}</span>
              </li>)}
          </ul>

          <a href="https://trysaffron.faithandfig.com" target="_blank" rel="noopener noreferrer" className="block" data-id="element-59">
            <button className="w-full bg-[#C9A961] hover:bg-[#C9A961]/90 text-white font-bold py-4 px-8 rounded-lg transition-colors flex items-center justify-center gap-2 text-lg" data-id="element-60">
              Try 4:14 Saffron Risk-Free →
              <ExternalLink className="w-5 h-5" data-id="element-61" />
            </button>
          </a>
        </div>

        {/* Legal Disclaimer */}
        <div className="mt-12 pt-8 border-t border-[#E8E4DD]" data-id="element-62">
          <h3 className="text-sm font-bold text-[#1A2332]/70 mb-3" data-id="element-63">
            Disclaimer
          </h3>
          <p className="text-xs text-[#1A2332]/50 leading-relaxed" data-id="element-64">
            4:14 Saffron is a botanical and not a prescription medication. It is
            not intended to diagnose, treat, cure, or prevent any disease. It
            should not be considered a replacement for professional medical
            advice or treatment. Always consult your doctor before starting any
            new supplement, especially if you are pregnant, nursing, taking
            medication, or have any medical conditions. This article is for
            informational purposes only and is not intended to diagnose, treat,
            cure, or prevent any disease. Always consult your healthcare
            provider before starting any new supplement, especially if you are
            pregnant, nursing, taking medications, or have a medical condition.
            Statements regarding dietary supplements have not been evaluated by
            the FDA. Individual results may vary. . For legal and compliance
            reasons, we do not compare Saffron 4:14 to prescription medications.
            No images or brand names of such medications are shown on this page.
            The statements on this page have not been evaluated by the FDA. This
            product is not intended to diagnose, treat, cure, or prevent any
            disease. Individual results may vary. This is an independent review
            and not affiliated with any pharmaceutical company.
          </p>
        </div>
      </div>
    </div>;
}